export default __webpack_public_path__ + "locales/en/PDFFormDialog.json?hash=ede099087e755521727933db94cf780c";